import React from 'react'

import styles from './LayoutContainer.module.css'

const LayoutContainer = ({ children, hideXS, ...rest }) => {
  return (
    <div className={styles.container} {...rest}>
      {children}
    </div>
  )
}

export default LayoutContainer



// WEBPACK FOOTER //
// ./src/components/shared/LayoutContainer.js